var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04163 18C9.04163 13.0524 13.0524 9.04163 18 9.04163C22.9475 9.04163 26.9583 13.0524 26.9583 18C26.9583 22.9475 22.9475 26.9583 18 26.9583C13.0524 26.9583 9.04163 22.9475 9.04163 18ZM18 10.2916C13.7428 10.2916 10.2916 13.7428 10.2916 18C10.2916 22.2572 13.7428 25.7083 18 25.7083C22.2572 25.7083 25.7083 22.2572 25.7083 18C25.7083 13.7428 22.2572 10.2916 18 10.2916Z",
    fill: "#366EE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9584 13.8333C16.9584 14.4086 17.4247 14.875 18 14.875C18.5753 14.875 19.0417 14.4086 19.0417 13.8333C19.0417 13.258 18.5753 12.7916 18 12.7916C17.4247 12.7916 16.9584 13.258 16.9584 13.8333ZM16.9584 18C16.9584 18.5753 17.4247 19.0416 18 19.0416C18.5753 19.0416 19.0417 18.5753 19.0417 18C19.0417 17.4247 18.5753 16.9583 18 16.9583C17.4247 16.9583 16.9584 17.4247 16.9584 18ZM18 23.2083C17.4247 23.2083 16.9584 22.7419 16.9584 22.1666C16.9584 21.5913 17.4247 21.125 18 21.125C18.5753 21.125 19.0417 21.5913 19.0417 22.1666C19.0417 22.7419 18.5753 23.2083 18 23.2083Z",
    fill: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.09709b0fbb82536e56332e198c7f1501.svg";
export { ForwardRef as ReactComponent };